const queryKeys = {
    getDashboard: (teacherId: string) => ["dashboard", { teacherId }] as const,
    getLearningSet: (learningSetId: string, queryParams: { depth?: number }) =>
        ["mapping", learningSetId, queryParams] as const,
    getExternalRedirection: (url: string) =>
        ["externalRedirection", url] as const,
};
export default queryKeys;
